export default {
    language: 'sv-SE',
    navigation: 'Tillbaka',
    home: {
        title: 'Färgberäknare',
        subtitle:
            'Låt oss hjälpa dig att välja det bästa bottenfärgsystemet till din båt och beräkna hur mycket du behöver',
        findProduct: 'Få Produkt',
        calculateVolume: 'Beräkna produktvolymen'
    },
    find: {
        questions: {
            type: '<strong>Typ</strong> av båt?',
            material: 'Båt<strong>material</strong>?',
            sailFrequency: '<strong>Hur ofta</strong> använder du båten?',
            paintLocation: '<strong>Var</strong> målar du din båt?',
            waterType: 'I vilken <strong>typ av vatten</strong> använder du din båt?'
        },
        answers: {
            help: 'Behöver du hjälp med att välja bottenfärg?',

            type: [
                {
                    label: 'Segelbåt',
                    icon: 'sailingBoat',
                    value: 'sailing'
                },
                {
                    label: 'Motorbåt',
                    sublabel: 'upp till 20 knop',
                    icon: 'motorboatSlow',
                    value: 'motor-slow'
                },
                {
                    label: 'Motorbåt (snabb)',
                    sublabel: 'snabbare än 20 knop',
                    icon: 'motorboatFast',
                    value: 'motor-fast'
                }
            ],
            material: [
                {
                    label: 'Glasfiber',
                    value: 'plastic'
                },
                {
                    label: 'Järn',
                    value: 'iron'
                },
                {
                    label: 'Trä',
                    value: 'wood'
                },
                {
                    label: 'Aluminium',
                    value: 'aluminium'
                }
            ],
            sailFrequency: [
                {
                    label: 'Sällan',
                    sublabel: '1-2 gånger per månad eller mindre',
                    value: 'low'
                },
                {
                    label: 'Ofta',
                    sublabel: '1-2 gånger per vecka',
                    value: 'medium'
                },
                {
                    label: 'Mycket ofta',
                    sublabel: 'Nästan varje dag',
                    value: 'high'
                }
            ],
            paintLocation: [
                {
                    label: 'Välj land',
                    countries: [
                        { label: 'UK', value: 'en-GB' },
                        { label: 'US', value: 'en-US' },
                        { label: 'Kanada', value: 'en-CA' },
                        { label: 'Danmark', value: 'da-DK' },
                        { label: 'Spanien', value: 'es-ES' },
                        { label: 'Finland', value: 'fi-FI' },
                        { label: 'Tyskland', value: 'de-DE' },
                        { label: 'Grekland', value: 'el-GR' },
                        { label: 'Kroatien', value: 'hr-HR' },
                        { label: 'Norge', value: 'nb-NO' },
                        { label: 'Nederländerna', value: 'nl-NL' },
                        { label: 'Sverige - östkusten', value: 'sv-SE_e' },
                        { label: 'Sverige - västkusten', value: 'sv-SE_w' },
                        { label: 'Sverige - sjöar', value: 'sv-SE_l' }
                    ]
                }
            ],
            waterType: [
                { label: 'Hav/Ocean', value: 'sea/ocean' },
                { label: 'Flod', value: 'rivers' },
                { label: 'Sjöar', value: 'lakes' }
            ]
        },
        result: {
            heading: 'Rekommenderar vi',
            selection: {
                title: 'Ditt val',
                type: 'Typ av båt',
                waterType: 'Vattentyp',
                material: 'Båtmaterial',
                sailFrequency: 'Aktivitet',
                country: 'Land'
            },
            category: {
                premium: 'Premium',
                alternative: 'Biocide-free Premium',
                bestBuy: 'Bästa köp',
                economic: 'Economic',
                bestBuyAlternative: 'Biocide-free Bästa köp',
                economicAlternative: 'Biocide-free Economic'
            },
            findOutMore: 'Få mer',
            whereToBuy: 'Var man kan köpa',
            email: 'e-postadress',
            send: 'Skicka',
            feedback: {
                title: 'Var informationen till någon hjälp?',
                yes: 'Ja',
                no: 'Nej',
                comment: 'Kommentar',
                placeholder: 'Kommentar'
            },
            recommendation: {
                title: 'Skicka rekommendationen via e-post'
            },
            calculateVolume: 'Beräkna volymen'
        }
    },
    calculate: {
        letsCalculate: 'Låt oss beräkna',
        questions: {
            antifouling: 'Välj Bottenfärg',
            keelType: '<strong>Köl</strong> typ?',
            dimensions: 'Båtens <strong>mått</strong>?'
        },
        answers: {
            keelType: [
                {
                    label: 'Fenköl',
                    icon: 'finKeel',
                    value: 'fin'
                },
                {
                    label: 'Fullköl',
                    icon: 'fullKeel',
                    value: 'full'
                }
            ],
            dimensionTitles: [
                {
                    title: 'Individuella mått'
                },
                {
                    title: 'ELLER undervattensyta i m2'
                }
            ],
            dimensions: [
                {
                    type: 'unit',
                    label: 'Enhet',
                    values: [{ label: 'Meter', value: 'm' }, { label: 'Feet', value: 'f' }],
                    valuesUS: [{ label: 'Feet', value: 'f' }, { label: 'Meters', value: 'm' }]
                },
                {
                    type: 'waterline',
                    label: 'Vattenlinjens längd'
                },
                {
                    type: 'beam',
                    label: 'Största bredd'
                },
                {
                    type: 'draft',
                    label: 'Utkast'
                },
                {
                    type: 'm2',
                    label: 'm2'
                }
            ]
        },
        result: {
            heading: 'Krävs produktvolym',
            selection: {
                title: 'Ditt val',
                antifouling: 'Bottenfärger',
                type: 'Typ av båt',
                material: 'Båtmaterial',
                sailFrequency: 'Aktivitet',
                country: 'Land',
                keelType: 'Köl typ',
                dimensions: 'Båtens mått'
            },
            category: {
                premium: 'Premium',
                alternative: 'Biocide-free Premium',
                bestBuy: 'Bästa köp',
                economic: 'Economic',
                bestBuyAlternative: 'Biocide-free Bästa köp',
                economicAlternative: 'Biocide-free Economic'
            },
            suggestedAmount: 'Rekommenderad mängd',
            suggestedAmountTwoCoats: 'Rekommenderad mängd (2 lager)',
            oneCoat: '(1 lager)',
            fiveCoats: '(5 lager)',
            primerAltTiecoatSilic: 'Glöm aldrig att använda SilicOne Tiecoat!',
            primerAltSilicSealSilic:
                '<strong>FALL 2</strong><br/>Applicering på gammal bottenfärg i bra skick - enkel övergång till Silic One',
            primerAlLightSilic:
                '<strong>FALL 1</strong><br/>Borttagning av gammal bottenfärg och applicering av produkten &ny båt utan epoxi',

            primerAltTiecoat:
                '<strong>FALL 2: Steg 2</strong><br/>…och därefter ett lager av Conversion Primer.',
            primerAltSilicSeal:
                '<strong>FALL 2: Steg 1</strong><br/>Båtar utan befintlig bottenfärg börja med att applicera ett lager av Light Primer…  (fortsätt till steg 2)',
            primerAlLight:
                '<strong>FALL 1</strong><br/>Måla över befintlig båtbottenfärg i bra skick.',
            primer:
                'Har båtens skrov mycket skador eller är det första gången som du målar båten? Allt du behöver ...',
            whereToBuy: 'Var man kan köpa',
            email: 'e-postadress',
            send: 'Skicka',
            or: 'ELLER',
            feedback: {
                title: 'Var informationen till någon hjälp?',
                yes: 'Ja',
                no: 'Nej',
                comment: 'Kommentar',
                placeholder: 'Kommentar'
            },
            recommendation: {
                title: 'Skicka rekommendationen via e-post'
            },
            calculateVolume: 'Beräkna volymen'
        }
    },
    map: {
        country: 'Land',
        city: 'Stad',
        getDirections: 'Få anvisningar',
        placeholder: 'Alla städer...'
    },
    footer: 'Hempel Yacht – Allt du behöver veta för att måla båten'
}
